// Keys can roll out before the mutation queue is enabled on the backend.
export const keyPermissionsEnabled = import.meta.env.VITE_ENABLE_KEY_PERMISSIONS === 'true';
export const unifiedMutationsEnabled = import.meta.env.VITE_ENABLE_UNIFIED_MUTATIONS === 'true';
